module.exports = __webpack_public_path__ + "img/tfw_logo_light.f5179832.png";